import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import React from 'react';

export default function DeleteIcon() {
    return (
        <DeleteRoundedIcon />
    );
}